$(function () { 
	const $sortBy = $(".single-challenge .dialog-box .sort-by");
	$sortBy.on("click", function (e) { 
		$sortBy.toggleClass('open');
	});
});
/**
 * @namespace
 * @global
 */
const Challenges = {

};